import { render } from "./landingcards.vue?vue&type=template&id=13794730"
import script from "./landingcards.vue?vue&type=script&lang=js"
export * from "./landingcards.vue?vue&type=script&lang=js"

import "./landingcards.vue?vue&type=style&index=0&id=13794730&lang=scss"
script.render = render

export default script